import React, { memo } from 'react';
import {
  GridColDef,
  Icon,
  Card,
  Popover,
  Stack,
  Clickable,
  P,
} from '@fashionnovateam/nova-ui-toolkit';

interface ActionsCellProps {
  tagId: string;
  onEdit: (id: string) => void;
  onDuplicate: (id: string) => void;
  onPrint: (id: string) => void;
}

export const ActionsCell = memo(
  ({ tagId, onEdit, onDuplicate, onPrint }: ActionsCellProps) => (
    <Popover position="bottom-left" offset={10}>
      <Popover.IconButton
        icon={<Icon name="three-dots-menu/three-dots-menu-horizontal" />}
        className="transform rotate-90 mt-2"
        label="More Actions"
        color="secondary"
      />
      <Popover.Content>
        <Card className="w-60">
          <Card.Body>
            <Clickable
              onClick={() => onEdit(tagId)}
              className="self-stretch px-3 hover:bg-neutral-100"
            >
              <Stack direction="row" align="center" className="gap-[10px]">
                <Icon
                  name="pencil-edit/pencil-edit"
                  className="text-[#1D24338C] text-md"
                />
                <P>Edit</P>
              </Stack>
            </Clickable>
            <Clickable
              onClick={() => onPrint(tagId)}
              className="self-stretch px-3 hover:bg-neutral-100"
            >
              <Stack direction="row" align="center" className="gap-[10px]">
                <Icon name="printer" className="text-[#1D24338C] text-md" />
                <P>Print</P>
              </Stack>
            </Clickable>
            <Clickable
              onClick={() => onDuplicate(tagId)}
              className="self-stretch px-3 hover:bg-neutral-100"
            >
              <Stack direction="row" align="center" className="gap-[10px]">
                <Icon
                  name="copy/copy-default"
                  className="text-[#1D24338C] text-md"
                />
                <P>Duplicate & Create New</P>
              </Stack>
            </Clickable>
          </Card.Body>
        </Card>
      </Popover.Content>
    </Popover>
  ),
);

ActionsCell.displayName = 'ActionsCell';

export const sampleTagsColumns: GridColDef[] = [
  {
    field: 'photo',
    headerName: 'Photo',
    render: 'custom',
    flex: 0.5,
    sortable: false,
    minWidth: 80,
    disableColumnMenu: true,
  },
  {
    field: 'style_number',
    headerName: 'Style Number',
    render: 'custom',
    flex: 0.5,
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'type_of_sample_tag',
    headerName: 'Type',
    render: 'badge',
    flex: 0.5,
    sortable: true,
    minWidth: 100,
  },
  {
    field: 'po_number',
    headerName: 'PO Number',
    render: 'custom',
    flex: 0.5,
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'created_at',
    headerName: 'Created',
    render: 'custom',
    flex: 3.5,
    sortable: true,
    minWidth: 120,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    render: 'custom',
    flex: 0.25,
    sortable: false,
    minWidth: 80,
    disableColumnMenu: true,
  },
];
